<script lang="ts" setup>
export interface FormKitCustomNote {
    value: string
}

const props = defineProps<FormKitCustomNote>()
</script>
<!-- eslint-disable vue/no-v-html -->
<template>
  <Typo class="formkit-outer">
    <div
      class="fs-xsmall"
      v-html="props.value"
    />
  </Typo>
</template>
